module.exports = __webpack_public_path__ + "img/type11.05395149.png";